import script from "./TaskCreationView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCreationView.vue?vue&type=script&setup=true&lang=js"

import "./TaskCreationView.vue?vue&type=style&index=0&id=df5c8f50&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df5c8f50"]])

export default __exports__